import { Action, ACTION_TYPE, ERROR_CODE } from '@abiglobalhealth/go-types'

import { actionsRequest } from '@/api/utils'

export const getCurrentUserConsultation = async <T extends Action<ACTION_TYPE.GET_CURRENT_USER_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.GET_CURRENT_USER_CONSULTATION
  })

  return body.data
}

export const createMedicalConsultation = async <T extends Action<ACTION_TYPE.CREATE_MEDICAL_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CREATE_MEDICAL_CONSULTATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const createPrescriptionRequest = async <T extends Action<ACTION_TYPE.CREATE_PRESCRIPTION_REQUEST>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CREATE_PRESCRIPTION_REQUEST
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const uploadAttachment = async <T extends Action<ACTION_TYPE.UPLOAD_ATTACHMENT>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.UPLOAD_ATTACHMENT
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const cancelConsultation = async <T extends Action<ACTION_TYPE.CANCEL_CONSULTATION>>(
  payload: T['payload'],
  signal?: AbortSignal
): Promise<T['response']> => {
  const body = await actionsRequest<T>(
    {
      payload,
      type: ACTION_TYPE.CANCEL_CONSULTATION
    },
    signal
  )

  return body.data ?? null
}

export const createFollowUpConsultation = async <T extends Action<ACTION_TYPE.CREATE_MEDICAL_FOLLOW_UP_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CREATE_MEDICAL_FOLLOW_UP_CONSULTATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const rateConsultation = async <T extends Action<ACTION_TYPE.RATE_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.RATE_CONSULTATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const closeSession = async <T extends Action<ACTION_TYPE.CLOSE_SESSION>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CLOSE_SESSION
  })

  return body.data
}

export const setCaseNotification = async <T extends Action<ACTION_TYPE.SET_CASE_NOTIFICATION>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_CASE_NOTIFICATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const createVideoConsultation = async <T extends Action<ACTION_TYPE.CREATE_VIDEO_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CREATE_VIDEO_CONSULTATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const videoCallHungUp = async <T extends Action<ACTION_TYPE.VIDEO_CALL_HUNG_UP>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.VIDEO_CALL_HUNG_UP
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const videoCallJoined = async <T extends Action<ACTION_TYPE.VIDEO_CALL_JOINED>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.VIDEO_CALL_JOINED
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const checkConsultationLimitExceeded = async <T extends Action<ACTION_TYPE.CHECK_CONSULTATION_LIMIT_EXCEEDED>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CHECK_CONSULTATION_LIMIT_EXCEEDED
  })

  return body.data ?? null
}

export const swapConsultation = async <T extends Action<ACTION_TYPE.SWAP_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SWAP_CONSULTATION
  })

  return body.data ?? null
}

export const viewReferralUrgency = async <T extends Action<ACTION_TYPE.VIEW_REFERRAL_URGENCY>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.VIEW_REFERRAL_URGENCY
  })

  return body.data ?? null
}

export const registerReferral = async <T extends Action<ACTION_TYPE.REGISTER_REFERRAL>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.REGISTER_REFERRAL
  })

  return body.data ?? null
}

export const createMentalHealthEvaluation = async <T extends Action<ACTION_TYPE.CREATE_MENTAL_HEALTH_CONSULTATION>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CREATE_MENTAL_HEALTH_CONSULTATION
  })

  if (!body?.data) throw new Error(ERROR_CODE.NO_DATA)

  return body.data
}

export const closeConsultation = async <T extends Action<ACTION_TYPE.CLOSE_CONSULTATION>>(payload: T['payload']): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.CLOSE_CONSULTATION
  })

  return body.data ?? null
}
